import React, { useState } from 'react'
import { Table, Tag, Collapse, Checkbox } from 'antd'
import t from 'lib/translations'
import './index.css'
import moment from 'moment'

const colorByState = {
  // These are the most important states, no need to color all of them
  delivered: 'green',
  ready_for_invoice: 'blue',
}

const columns = [
  {
    title: 'EFKT ref',
    dataIndex: 'orderContainerId',
    key: 'orderContainerId',
  },
  {
    title: 'Booking ID',
    dataIndex: 'bookingId',
    key: 'bookingId',
  },
  {
    title: 'Dato',
    dataIndex: 'date',
    render: (date) => {
      return date ? moment(date).format('YYYY-MM-DD') : '-'
    },
  },
  {
    title: 'Beskrivelse',
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Antall',
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: 'Enhetpris',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
  },
  {
    title: 'Status',
    key: 'status',
    render: (invoice) => {
      return (
        <Tag color={colorByState[invoice.state] || ''}>
          {t(`invoiceLineState.${invoice.state}`)}
        </Tag>
      )
    },
  },
  {
    title: 'Sum',
    key: 'sum',
    render: (invoice) => {
      return (invoice.quantity * invoice.unitPrice).toFixed(2)
    },
  },
]

const Invoices = ({ loading, invoiceLines }) => {
  const invoiceLineStates = Object.keys(t(`invoiceLineState`))
  const [filter, setFilter] = useState([
    'awaiting_first_time_review',
    'awaiting_review',
    'changes_accepted',
    'delivered',
    'ready_for_invoice',
  ])

  const filteredInvoices = invoiceLines.filter((invoice) =>
    filter.includes(invoice.state)
  )

  return (
    <div>
      <Collapse className="filterer">
        <Collapse.Panel
          header={`Filtrer etter status (${filter.length})`}
          disabled={!invoiceLines.length}
        >
          <Checkbox.Group
            defaultValue={filter}
            options={invoiceLineStates.map((state) => ({
              label: t(`invoiceLineState.${state}`),
              value: state,
            }))}
            onChange={(e) => setFilter(e)}
          />
        </Collapse.Panel>
      </Collapse>

      <Table
        loading={loading}
        size="small"
        pagination={false}
        columns={columns}
        dataSource={filteredInvoices.map((invoice) => ({
          ...invoice,
          key: invoice.id,
          date: invoice.bookingStartsAt || invoice.readyToBeInvoicedAt,
        }))}
        footer={() => (
          <>
            <strong>Antall</strong>: {filteredInvoices.length} <br />
            <strong>Sum:</strong>{' '}
            {filteredInvoices.reduce((sum, curr) => {
              return (sum += curr.quantity * curr.unitPrice)
            }, 0).toFixed(2)}
          </>
        )}
      />
    </div>
  )
}

export default Invoices
